module.exports = __webpack_public_path__ + "static/media/secondAssessmentPhoto.c77eeaee.png";